<template>
    <div class="toast-wrapper" v-if="visible">
        {{text}}
    </div>
  </template>
  <script>
  export default {
      name: 'n-toast',
    timer: null,
    data(){
        return {
            text: '',
            visible: false
        }
    },
    methods: {
          show(text, time) { 
            this.text = text
            this.visible = true
            this.timer && clearTimeout(this.timer)
              this.timer = setTimeout(() => { 
                    this.text = ''
                    this.visible = false
              }, time || 1500)
          }
    }
  }
  </script>
  <style lang="less">
   .toast-wrapper {
       position: fixed;
       bottom: 50%;
       left: 50%;
       width: 16rem;
       min-height: 2rem;
       line-height: 2rem;;
       background: rgba(0, 0, 0, .8);
       border-radius: 1rem;
       margin-left: -8rem;
       text-align: center;
       padding: 1rem;
       font-size: 1.2rem;
       color: #0994ff;
       z-index: 9999;
       color: #fff;
       animation: toastAnimation 300ms;
   }
   @keyframes toastAnimation {
     from {
       opacity: 0;
     }
     to {
       opacity: 1;
     }
   }
  </style>
  


// WEBPACK FOOTER //
// src/components/ui/n-toast.vue